import { loopThroughElements } from "./loop-through-elements";

/**
 * Bind all elements of a class to a component type and get resulting components as an array
 * @param className Name of CSS class to bind component type to
 * @param initializer Method to instantiate component given an HTML Element
 */
export function bindComponentsToClass<TComponent>(className: string, initializer: (HTMLElement: HTMLElement) => TComponent, rootElement?: Element) {
    const components = [];
    loopThroughElements((rootElement || document).getElementsByClassName(className), element => components.push(initializer(element)));
    return components;
}